export default __webpack_public_path__ + "static/media/plastic.1db93d06.svg";